<template>
	<!--视频音频文件上传-->
	<div>
		<div v-if="noneBtnFile" style="position: relative">
			<video :src="fileUrl" class="avatar" controls="controls" />
			<i class="el-icon-circle-close" @click="fileChange" />
		</div>
		<el-upload v-else :class="{uoloadSty:showBtnFile,disUoloadSty: noneBtnFile}" action="#" list-type="picture-card"
			:http-request="UploadFile" :limit="1" :on-change="fileChange" accept=".mp4,.mp3,.avi">
			<i class="el-icon-plus" />
		</el-upload>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "../../request/apis.js"
	export default {
		props: {
			fileUrl: {
				type: String
			}
		},
		data() {
			return {
				showBtnFile: true,
				noneBtnFile: false,
			};
		},
		mounted() {
			this.noneBtnFile = this.fileUrl != ''
		},
		methods: {
			UploadFile(param) {
				var fileSize = param.file.size / 1024 / 1024 < 50; //控制大小  修改50的值即可
				if (["video/mp4", "video/avi", "video/mp3"].indexOf(param.file.type) == -1) {
					this.$message.error("请上传格式正确的文件");
					return false;
				}
				if (!fileSize) {
					this.$message.error("文件大小不能超过50M");
					return false;
				}
				const formData = new FormData();
				formData.append("file", param.file);
				formData.append("category", '1');
				uploadFile(formData).then(res => {
					if (res != -1) {
						this.$emit('saveFile', res)
					} else {
						this.$message.error('文件上传服务器失败！请重新上传');
					}
				}).catch(err => {})
			},

			//显示与隐藏上传按钮
			fileChange() {
				this.noneBtnFile = !this.noneBtnFile;
				if (!this.noneBtnFile) {
					this.$emit('delFile')
				}
			}
		}
	}
</script>
<style scoped>
	/deep/.uoloadSty .el-upload--picture-card {
		width: 100px;
		height: 100px;
		line-height: 100px;
		margin-right: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/deep/.uoloadSty .el-upload-list--picture-card .el-upload-list__item {
		width: 100px;
		height: 100px;
		margin-right: 20px;
		border: 1px dashed #c0ccda;
	}

	/deep/.disUoloadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar {
		width: 100px;
		height: 100px;
		display: block;
		margin-right: 20px;
		border-radius: 5px;
		border: 1px dashed #c0ccda;
	}

	.el-icon-circle-close {
		font-size: 20px;
		color: red;
		position: absolute;
		top: -9px;
		right: 9px;
		z-index: 99999;
	}
</style>